/**
 * Auth domain service. Uses Spring Boot backend: POST /auth/login returns JWT + user;
 * verifyToken uses GET /auth/me with Bearer token.
 */
import apiService from './api.service';
import { API_CONFIG } from '../config/api.config';
import { STORAGE_KEYS } from '../config/app.config';

export function getStoredAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.AUTH);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setStoredAuth(data) {
  if (!data) {
    localStorage.removeItem(STORAGE_KEYS.AUTH);
    return;
  }
  localStorage.setItem(STORAGE_KEYS.AUTH, JSON.stringify(data));
}

/**
 * Verify that stored JWT is still valid (GET /auth/me).
 */
export async function verifyToken() {
  const auth = getStoredAuth();
  if (!auth?.user || !auth?.token) return null;
  try {
    const user = await apiService.get(API_CONFIG.ENDPOINTS.AUTH_ME, {}, { showToastOnError: false });
    return { token: auth.token, user };
  } catch {
    setStoredAuth(null);
    return null;
  }
}

/**
 * Login: call backend POST /auth/login, store token + user, return { user }.
 */
export async function login(credentials) {
  const { username, password } = credentials;
  const response = await apiService.post(API_CONFIG.ENDPOINTS.AUTH_LOGIN, { username, password });
  const data = { token: response.token, user: response.user };
  setStoredAuth(data);
  return data;
}

export function logout() {
  setStoredAuth(null);
}

export default {
  getStoredAuth,
  setStoredAuth,
  verifyToken,
  login,
  logout,
};
